umpApp.onResize = function () {
    ratio = window.innerWidth / window.innerHeight;

    console.log('ratio: ', ratio);
};